var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.generateMapFlag)?[_c('MapBoxMap',{attrs:{"generateMapFlag":_vm.generateMapFlag,"geoJsonData":_vm.geoJsonData}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }